import React, { useState, useMemo, forwardRef } from 'react'
import { Tree, TreeNode } from '@ow/comps'

const Render = function ({ opts = {}, onChange }, ref) {
  const datas = opts.treeData
  const [checkedKeys, setCheckedKeys] = useState([])
  const loop = (d) =>
    d.map((item) => {
      if (item.children) {
        return (
          <TreeNode key={item.objectId} title={item.title}>
            {loop(item.children)}
          </TreeNode>
        )
      }
      return <TreeNode key={item.objectId} title={item.title} />
    })
  const treeNodes = useMemo(() => {
    return loop(datas)
  }, [datas])
  const onCheck = (keys) => {
    setCheckedKeys(keys)
    onChange(keys)
  }
  return (
    <Tree
      multiple
      showLine
      checkable
      checkedKeys={checkedKeys}
      onCheck={onCheck}
      defaultExpandedKeys={[]}
      defaultSelectedKeys={[]}
      height={160}
    >
      {treeNodes}
    </Tree>
  )
}

export default forwardRef(Render)
